import { Sparkles } from 'lucide-react';
import { ORB_GRADIENT } from '../constants';

// Conversational header inside the setup panel (DC §4.2). The orb gradient is
// the canonical Signal-Analyst orb, identical at every size app-wide.
export function SignalAnalystHeader({ brandName }: { brandName: string }) {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 13, marginBottom: 22 }}>
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 34,
          height: 34,
          borderRadius: 10,
          background: ORB_GRADIENT,
          color: '#fff',
          flexShrink: 0,
          boxShadow: 'var(--shadow-spectral-violet-glow)',
        }}
      >
        <Sparkles style={{ width: 14, height: 14 }} />
      </span>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: '.07em',
            textTransform: 'uppercase',
            color: 'var(--spectral-violet)',
            marginBottom: 5,
          }}
        >
          Signal Analyst
        </div>
        <h2
          style={{
            fontSize: 24,
            fontWeight: 600,
            letterSpacing: '-.015em',
            color: 'var(--foreground)',
            margin: '0 0 4px',
          }}
        >
          Which product would you like me to analyze?
        </h2>
        <p style={{ fontSize: 14, lineHeight: 1.55, color: 'var(--muted-foreground)', margin: 0 }}>
          I'll trace how every model reasons about it, then show you exactly where perception is shaped.
        </p>
      </div>

      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 7,
          height: 28,
          padding: '0 12px',
          borderRadius: 99,
          background: 'var(--card)',
          border: '1px solid var(--border)',
          fontSize: 12,
          color: 'var(--muted-foreground)',
          flexShrink: 0,
        }}
      >
        Brand <span style={{ fontWeight: 600, color: 'var(--foreground)' }}>{brandName}</span>
      </span>
    </div>
  );
}
